export default "__VITE_ASSET__DsJkhtW$__"